<!-- TEMPLATE -->
<template>
  <div class="dean-spinner">
    <dean-icon
      class="dean-spinner-icon"
      :glyph="spinnerType"
      :height="size"
      :width="size"
    ></dean-icon>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import bouncingLinesSpinner from '../svg/spinners/bouncing-lines.svg';
import fadingLinesSpinner from '../svg/spinners/fading-lines.svg';
import fullCircleSpinner from '../svg/spinners/full-circle.svg';
import halfCircleSpinner from '../svg/spinners/half-circle.svg';
import jumpingLinesSpinner from '../svg/spinners/jumping-lines.svg';
import pulseFadeLinesSpinner from '../svg/spinners/pulse-fade-lines.svg';
import pulsingLinesSpinner from '../svg/spinners/pulsing-lines.svg';
import quarterCircleSpinner from '../svg/spinners/quarter-circle.svg';

import deanIcon from './deanIcon.vue';
import myHeader from './myHeader.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class mySpinner extends Vue {
  // PROPS
  @Prop() data!: object;
  @Prop({ default: false }) bouncingLines!: boolean;
  @Prop({ default: false }) fadingLines!: boolean;
  @Prop({ default: false }) fullCircle!: boolean;
  @Prop({ default: false }) halfCircle!: boolean;
  @Prop({ default: false }) jumpingLines!: boolean;
  @Prop({ default: false }) pulseFadeLines!: boolean;
  @Prop({ default: false }) pulsingLines!: boolean;
  @Prop({ default: false }) quarterCircle!: boolean;
  @Prop({ default: '20' }) size!: string;
  @Prop() animation!: object;

  bouncingLinesSpinner: object = bouncingLinesSpinner;
  fadingLinesSpinner: object = fadingLinesSpinner;
  fullCircleSpinner: object = fullCircleSpinner;
  halfCircleSpinner: object = halfCircleSpinner;
  jumpingLinesSpinner: object = jumpingLinesSpinner;
  pulseFadeLinesSpinner: object = pulseFadeLinesSpinner;
  pulsingLinesSpinner: object = pulsingLinesSpinner;
  quarterCircleSpinner: object = quarterCircleSpinner;

  // COMPUTED
  get spinnerType() {
    let value = this.fullCircleSpinner;
    if (this.bouncingLines) value = this.bouncingLinesSpinner;
    else if (this.fadingLines) value = this.fadingLinesSpinner;
    else if (this.fullCircle) value = this.fullCircleSpinner;
    else if (this.halfCircle) value = this.halfCircleSpinner;
    else if (this.jumpingLines) value = this.jumpingLinesSpinner;
    else if (this.pulseFadeLines) value = this.pulseFadeLinesSpinner;
    else if (this.pulsingLines) value = this.pulsingLinesSpinner;
    else if (this.quarterCircle) value = this.quarterCircleSpinner;
    else value = this.fullCircleSpinner;
    if (this.animation) {
      value = this.animation;
    }
    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.dean-spinner {
  @include display-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100%;
  width: 100%;
  @media #{$small-down} {
    position: fixed;
    top: 0;
    left: 0;
  }
  .dean-spinner-icon {
    fill: var(--color-secondary, $color-secondary);
  }
}
</style>
